<template>
  <v-row>
    <LabelCol v-if="isLabelVisible" :cols="labelCols" :attribute="attribute" />
    <v-col :cols="valueCols" class="pa-0">
      <v-text-field
        :value="value"
        @input="setValue"
        :label="attribute.measure_unit?attribute.measure_unit:null"
        :readonly="!canEdit"
        :disabled="isCopied"
        :loading="loading"
        :rules="rules"
        outlined
        v-bind="inputProps"
      />
    </v-col>
  </v-row>
</template>

<script>
import LabelCol from './LabelCol';

import { DICTS } from '@/dicts';

export default {
  components: {
    LabelCol
  },
  props: {
    attribute: {
      required: true,
      type: Object
    },
    labelCols: {
      default: 4,
      type: Number
    },
    valueCols: {
      default: 8,
      type: Number
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    isCopied: {
      required: false,
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    value: {
      required: true
    },
    inputProps: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isLabelVisible: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  computed: {
    dicts: () => DICTS,
    rules() {
      const rules = [];
      if (this.attribute.required) {
        rules.push(value => !!value || this.$i18n.t('default.requiredField'));
      }
      return rules;
    }
  },
  methods: {
    setValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>
